if (!customElements.get('primo-subscription-accessibility')) {
  let sequence = 0;
  customElements.define('primo-subscription-accessibility', class extends HTMLElement {
    connectedCallback() {
      this.repair();
      this.observer = new MutationObserver(() => this.repair());
      this.observer.observe(this, { childList: true, subtree: true });
    }
    repair() {
      this.querySelectorAll('select.sss-selling-plan-select').forEach(select => {
        if (!select.getAttribute('aria-label') && !select.getAttribute('aria-labelledby') && !select.labels?.length) select.setAttribute('aria-label', 'Subscription delivery frequency');
      });
      this.querySelectorAll('input.subscription-plan-input').forEach(input => {
        const row = input.closest('.subscription-plan-wrapper');
        const label = row?.querySelector('.subscription-plan-details label');
        if (!label?.textContent.trim()) return;
        const labelled = input.getAttribute('aria-labelledby');
        const hasName = input.getAttribute('aria-label')?.trim() || (labelled && labelled.split(/\s+/).some(id => document.getElementById(id)?.textContent.trim())) || [...(input.labels || [])].some(item => item.textContent.trim());
        if (!hasName) {
          if (!input.id) input.id = `primo-plan-${++sequence}`;
          label.htmlFor = input.id;
        }
        const description = row.querySelector('.selling-plan-price-container');
        if (description && !input.hasAttribute('aria-describedby')) {
          if (!description.id) description.id = `primo-plan-price-${++sequence}`;
          input.setAttribute('aria-describedby', description.id);
        }
      });
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
